import axios from "@/utils/axios";
import { useQuery } from "@tanstack/react-query";

export interface NodeConfigData {
  multithread?: {
    min_threads: number;
    max_threads: number;
  };
  switch_condition?: {
    max_cases: number;
  };
  merge?: {
    min_entries: number;
    max_entries: number;
  };
  sign_document?: {
    max_optional_signers_per_block: number;
  };
}

export interface NodeConfigResponse {
  data: NodeConfigData;
}

export const useGetNodeConfig = () => {
  return useQuery({
    queryKey: ["node-config"],
    queryFn: async (): Promise<NodeConfigData> => {
      const response = await axios.get<NodeConfigResponse>(
        "/admin/v1/node/config",
      );
      return response.data.data;
    },
    staleTime: 5 * 60 * 1000,
  });
};

export const useGetSignDocumentConfig = () => {
  const { data, ...rest } = useGetNodeConfig();
  return {
    ...rest,
    config: data?.sign_document,
    maxOptionalSignersPerBlock:
      data?.sign_document?.max_optional_signers_per_block ?? 10,
  };
};
